var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectorRef } from '@angular/core';
import { ControlWidget } from '../angular2-schema-form-shim';
import { isWidgetRequired } from './overrides';
import { DomSanitizer } from '@angular/platform-browser';
var MessageWidget = (function (_super) {
    __extends(MessageWidget, _super);
    function MessageWidget(domSanitizer, ref) {
        var _this = _super.call(this) || this;
        _this.domSanitizer = domSanitizer;
        _this.ref = ref;
        return _this;
    }
    Object.defineProperty(MessageWidget.prototype, "widget", {
        get: function () {
            var widget = this.schema.widget;
            return typeof widget === 'string' ? { id: widget } : widget;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageWidget.prototype, "message", {
        get: function () {
            return this.domSanitizer.bypassSecurityTrustHtml(this.widget.content);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MessageWidget.prototype, "required", {
        get: function () {
            return isWidgetRequired(this);
        },
        enumerable: true,
        configurable: true
    });
    MessageWidget.prototype.ngAfterViewInit = function () {
        // Detatch iframes to prevent endless reloading during change detection
        if (/<iframe /.test(this.message)) {
            this.ref.detach();
        }
    };
    return MessageWidget;
}(ControlWidget));
export { MessageWidget };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/message.widget.ts.pre-build-optimizer.js